import it from './locales/it-IT/index.js'
import en from './locales/en-US/index.js'
import de from './locales/de-DE/index.js'

export default defineI18nConfig(() => ({
  legacy: false,
  messages: {
    it,
    en,
    de,
  },
}))
